import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  secondary: string | React.ReactNode;
  tertiary: string | React.ReactNode;
  right: React.ReactNode;
}

export const ListItem = (props: Props) => {
  const { icon, title, secondary, tertiary, right } = props;

  return (
    <ChakraV3.HStack gap={4} align='start' fontSize='sm'>
      <ChakraV3.Stack flexShrink={0}>{icon}</ChakraV3.Stack>
      <ChakraV3.Stack gap={1} minW={0} w='full' align='start'>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Stack fontWeight='semibold' lineClamp={1}>
            {title}
          </ChakraV3.Stack>
          <ChakraV3.Stack color='secondary' fontSize='xs'>
            {secondary}
          </ChakraV3.Stack>
        </ChakraV3.Stack>
        {tertiary}
      </ChakraV3.Stack>
      <ChakraV3.Spacer />
      <ChakraV3.Stack flexShrink={0}>{right}</ChakraV3.Stack>
    </ChakraV3.HStack>
  );
};
